window.jQuery(document).on('select2:open', e => {
  const id = e.target.id;
  const target = document.querySelector(`[aria-controls=select2-${id}-results]`);
  target.focus();
});
